import noop from "lodash.noop";

import PlacegroundPipeline, { EVENTS as PIPELINE_EVENTS } from "./PlacegroundPipeline";

abstract class AbstractARExperience {
    protected canvas: HTMLCanvasElement;
    protected pageId: number;
    protected deviceId: string;
    protected placegroundPipeline: PlacegroundPipeline | null = null;
    private onAssetPlayStartListener: Function;
    private onAssetPlayStopListener: Function;
    private onVideoPlayStartListener: Function;
    private onAssetLoadStartListener: Function;
    private onAssetLoadFinishedListener: Function;
    protected onErrorListener: Function;
    protected listeners: { [key in PIPELINE_EVENTS]?: Function };

    constructor(
        canvas: HTMLCanvasElement,
        pageId: number,
        deviceId: string,
        onAssetPlayStartListener: Function = noop,
        onAssetPlayStopListener: Function = noop,
        onVideoPlayStartListener: Function = noop,
        onAssetLoadStartListener: Function = noop,
        onAssetLoadFinishedListener: Function = noop,
        onAssetDisplayedListener: Function = noop,
        onAssetHiddenListener: Function = noop,
        onErrorListener: Function = noop
    ) {
        const videoList = document.getElementById("canvas-container").getElementsByTagName("video");
        Array.from(videoList).forEach(function(v) {
            v.play();
        });

        this.canvas = canvas;
        this.deviceId = deviceId;
        this.pageId = pageId;

        this.onAssetPlayStartListener = onAssetPlayStartListener;
        this.onAssetPlayStopListener = onAssetPlayStopListener;
        this.onVideoPlayStartListener = onVideoPlayStartListener;
        this.onAssetLoadStartListener = onAssetLoadStartListener;
        this.onAssetLoadFinishedListener = onAssetLoadFinishedListener;
        this.onErrorListener = onErrorListener;

        this.listeners = {
            [PIPELINE_EVENTS.ASSET_LOAD_START]: this.onAssetLoadStartListener,
            [PIPELINE_EVENTS.ASSET_LOAD_FINISHED]: this.onAssetLoadFinishedListener,
            [PIPELINE_EVENTS.ASSET_DISPLAYED]: onAssetDisplayedListener,
            [PIPELINE_EVENTS.ASSET_HIDDEN]: onAssetHiddenListener,
            [PIPELINE_EVENTS.ASSET_PLAY_START]: this.onPlayStart,
            [PIPELINE_EVENTS.ASSET_PLAY_STOP]: this.onPlayStop,
            [PIPELINE_EVENTS.VIDEO_PLAY_START]: this.onVideoPlayStart
        };
    }

    public playAsset(left: number, top: number) {
        this.placegroundPipeline?.playAssetOnScreen(left, top);
    }

    public stopPlayingAsset() {
        this.placegroundPipeline?.stopPlayingAsset();
    }

    private onPlayStart = () => {
        this.placegroundPipeline?.hideCursor();
        this.onAssetPlayStartListener();
    };

    private onPlayStop = () => {
        this.placegroundPipeline?.showCursor();
        this.onAssetPlayStopListener();
    };

    private onVideoPlayStart = () => {
        this.onVideoPlayStartListener();
    };

    public abstract initialize(): void;
    public abstract startPlacegroundSession(): Promise<unknown>;
    public abstract stopPlacegroundSession(): void;
}

export default AbstractARExperience;
